<template>
    <div class="o-knowledgeBaseItem u-w100 u-py20 u-overflowYAuto">
        <div class="o-knowledgeBaseItem__inner u-container u-overflowHidden">
            <img class="o-knowledgeBaseItem__img u-cover u-br u-mb20" v-if="article.thumbnail" :src="article.thumbnail" />
            <h1 class="o-knowledgeBaseItem__title" v-if="article.title">{{ article.title }}</h1>
            <div v-html="article.content"></div>
        </div>
    </div>
</template>

<script setup>
import { ref, onMounted, inject } from 'vue';
import api from '../services/api';

const currentId = inject('currentId');
const article = ref({});

const fetchArticle = async () => {
    try {
        const response = await api.get(`/article/${currentId.value}`);

        if (response.status === 200 && response.data.length !== 0) {
            article.value = response.data;
        }
        
    } catch (error) {
        console.error('Error fetching article:', error);
    }
};

onMounted(async () => {
    fetchArticle();
});
</script>